import { get } from 'lodash';
import { apiSlice } from '../../app/services/apiSlice';

const AUTH_URL = 'authentication/';
const vendor = 'vendor/florist/';
const payout = 'vendor/stripe/connected/account/payout/schedule';

export const shopApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResourseList: builder.query({
      query: () => ({
        url: `${AUTH_URL}resources`,
      }),
    }),
    getRoleList: builder.query({
      query: (params) => ({
        url: `${AUTH_URL}role`,
        params: { ...params },
      }),
    }),
    getFloriestDetails: builder.query({
      query: (params) => ({
        url: `${vendor}${params}`,
      }),
      keepUnusedDataFor: 0,
    }),
    getAllNormalUser: builder.query({
      query: (params) => ({
        url: `${AUTH_URL}user/normal`,
        params: { ...params },
      }),
    }),

    deleteNormalUsers: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}user/normal/deleteByIds`,
        method: 'DELETE',
        body: { deleteIds: [...data] },
      }),
    }),
    getAllShopBankAccount: builder.query({
      query: (params) => ({
        url: `${vendor}bankAccount`,
        params: { ...params },
      }),
    }),
    getShopBankAccountById: builder.query({
      query: (params) => ({
        url: `${vendor}bankAccount/${params}`,
      }),
    }),
    getNormalUserById: builder.query({
      query: (params) => ({
        url: `${AUTH_URL}user/normal/${params}`,
      }),
    }),
    getAllShopPolicy: builder.query({
      query: (params) => ({
        url: `vendor/floristPolicy`,
        params: { ...params },
      }),
    }),
    getAllBankList: builder.query({
      query: () => ({
        url: `vendor/bank`,
      }),
    }),
    getShopPolicyById: builder.query({
      query: (params) => ({
        url: `vendor/floristPolicy/${params}`,
      }),
    }),
    getRoleById: builder.query({
      query: (params) => ({
        url: `${AUTH_URL}role/${params}`,
      }),
    }),
    getFloralServices: builder.query({
      query: () => ({
        url: `/vendor/api/floralServices/getAllForDropDown`,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.objectData?.map((service) => ({
          ...service,
          value: service?.id,
          label: `${service?.name}`,
        }));
        return responseData || {};
      },
    }),
    createNormalUser: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}user/normal`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    createPolicy: builder.mutation({
      query: (data) => ({
        url: `vendor/floristPolicy`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    createBankAccount: builder.mutation({
      query: (data) => ({
        url: `${vendor}bankAccount`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    createNewRole: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}role`,
        method: 'POST',
        body: { ...data },
      }),
    }),
    updateNormalUser: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}/user/normal`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    updateFloriestDetails: builder.mutation({
      query: (data) => ({
        url: `${vendor}`,
        method: 'PUT',
        body: { ...data },
      }),
      invalidatesTags: ['preLiveChecks'],
    }),
    updatePolicy: builder.mutation({
      query: (data) => ({
        url: `vendor/floristPolicy`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    updateBankAccount: builder.mutation({
      query: (data) => ({
        url: `${vendor}bankAccount`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    updateRole: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}role`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    deleteShopPolicy: builder.mutation({
      query: (data) => ({
        url: `vendor/floristPolicy/${data?.id}`,
        method: 'DELETE',
        // body: { ...data?.payload },
      }),
    }),
    deleteShopPolicies: builder.mutation({
      query: (data) => ({
        url: `vendor/floristPolicy/deleteByIds`,
        method: 'DELETE',
        body: { deleteIds: [...data] },
      }),
    }),
    deleteShopBankAccount: builder.mutation({
      query: (data) => ({
        url: `${vendor}bankAccount/${data?.id}`,
        method: 'DELETE',
      }),
    }),
    deleteRoleById: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}role/${data?.id}`,
        method: 'DELETE',
      }),
    }),
    deleteRoles: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}role/deleteByIds`,
        method: 'DELETE',
        body: { deleteIds: [...data] },
      }),
    }),
    changeStatus: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}role/activeRole`,
        method: 'PUT',
        body: { ...data },
      }),
    }),
    deleteNormalUser: builder.mutation({
      query: (data) => ({
        url: `${AUTH_URL}user/normal/${data?.id}`,
        method: 'DELETE',
      }),
    }),

    getFloralSettingsBuID: builder.query({
      query: () => ({
        url: `vendor/api/florist/settings/getByFloristId`,
      }),
      providesTags: ['shopSettings'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    updateFloralSettings: builder.mutation({
      query: (data) => ({
        url: `/vendor/api/florist/settings`,
        method: 'POST',
        body: { ...data },
      }),
      invalidatesTags: ['shopSettings', 'preLiveChecks'],
    }),
    getAccountConnected: builder.query({
      query: () => ({
        url: `vendor/stripe/connected/account`,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    getOnboardingLink: builder.mutation({
      query: () => ({
        url: `vendor/stripe/connected/account/onboarding-link`,
      }),
      invalidatesTags: ['preLiveChecks'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    getDashboardLink: builder.mutation({
      query: () => ({
        url: `vendor/stripe/connected/account/stripe-dashboard-link`,
      }),
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    getRegionalSettings: builder.query({
      query: () => ({
        url: `/vendor/api/florist/regional/settings/getByFloristId`,
      }),
      providesTags: ['regionalSetting'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    updateRegionalSettings: builder.mutation({
      query: (data) => ({
        url: `/vendor/api/florist/regional/settings`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['regionalSetting', 'preLiveChecks'],
      transformResponse: (responseData) => {
        return responseData?.objectData || [];
      },
    }),
    updatePayoutSchedule: builder.mutation({
      query: (data) => ({
        url: payout,
        method: 'POST',
        body: data,
      }),
    }),

    getCatalogPayouts: builder.query({
      query: (params) => ({
        url: `inventory/api/customerCart/earned/commission`,
        params: { ...params },
      }),
    }), 

    addShopLocation: builder.mutation({
      query: (data) => ({
        url: `vendor/api/florist/locations`,
        method: 'POST',
        body: data,
      }),
    }),

    getLocationByFloristId: builder.query({
      query: (id) => ({
        url: `vendor/api/florist/locations/getByFloristId/${id}`,
        // params: { ...params },
      }),
    }), 

    updateDefaultLocationById: builder.mutation({
      query: (data) => ({
        url: `vendor/api/florist/locations/make-default/${data?.id}`,
        method: 'PUT',
        body: { ...data },
      }),
    }), 

    deleteLocationById: builder.mutation({
      query: (id) => ({
        url: `vendor/api/florist/locations/${id}`,
        method: 'DELETE',
      }),
    }),

    getLocationById: builder.query({
      query: (id) => ({
        url: `vendor/api/florist/locations/${id}`,
      }),
    }), 

    updateLocationById: builder.mutation({
      query: (data) => ({
        url: `vendor/api/florist/locations/${data?.id}`,
        method: 'PUT',
        body: { ...data },
      }),
    }),

  }),
});

export const {
  useGetAllNormalUserQuery,
  useGetRoleByIdQuery,
  useGetRoleListQuery,
  useGetResourseListQuery,
  useGetFloriestDetailsQuery,
  useGetAllShopBankAccountQuery,
  useGetAllBankListQuery,
  useGetAllShopPolicyQuery,
  useGetShopBankAccountByIdQuery,
  useGetNormalUserByIdQuery,
  useGetShopPolicyByIdQuery,
  useGetFloralServicesQuery,
  useCreateNormalUserMutation,
  useUpdateRoleMutation,
  useCreatePolicyMutation,
  useCreateBankAccountMutation,
  useUpdateNormalUserMutation,
  useUpdateFloriestDetailsMutation,
  useUpdatePolicyMutation,
  useUpdateBankAccountMutation,
  useDeleteShopPolicyMutation,
  useDeleteShopPoliciesMutation,
  useDeleteRoleByIdMutation,
  useDeleteRolesMutation,
  useDeleteShopBankAccountMutation,
  useDeleteNormalUserMutation,
  useCreateNewRoleMutation,
  useChangeStatusMutation,
  useDeleteNormalUsersMutation,
  useGetFloralSettingsBuIDQuery,
  useGetOnboardingLinkMutation,
  useGetDashboardLinkMutation,
  useGetAccountConnectedQuery,
  useUpdateFloralSettingsMutation,
  useGetRegionalSettingsQuery,
  useUpdateRegionalSettingsMutation,
  useUpdatePayoutScheduleMutation,
  useGetCatalogPayoutsQuery,

  //Shop Location
  useAddShopLocationMutation,
  useGetLocationByFloristIdQuery,
  useDeleteLocationByIdMutation,
  useLazyGetLocationByIdQuery,
  useUpdateLocationByIdMutation,
  useUpdateDefaultLocationByIdMutation
} = shopApiSlice;
